import type { PresetHOC } from '../types/PresetHOC';

/**
 * Add a property to the Viz class to inform that the viz should be displayed in the toolbar
 * @param {PresetItem} Item The preset item to enhance
 */
export const withToolbar: PresetHOC<{
    includeInToolbar?: boolean;
}> = (Item) => {
    Item.includeInToolbar = true;

    return Item;
};
